import { Form } from 'antd';
import React from 'react';
import { Select } from 'layout/Select';
import useMixpanel from 'utils/hooks/Mixpanel';
import { useHistory } from 'react-router-dom';

const CountryDropDown = ({ selected, label, allRegions, isLoading = false }) => {
  const mixpanelTrack = useMixpanel();
  const { push } = useHistory();

  const openCountryRoute = value => {
    const countryId = value.id;
    const luxeUrl = '/country-risk/' + countryId + '/';
    mixpanelTrack('Country Risk - Select Country from Dropdown', { country: value.label });
    push(luxeUrl);
  };

  return (
    <Form.Item
      style={{ width: '188px' }}
      colon={false}
      label={label ? <label style={{ color: 'white', marginLeft: 20 }}>{label}</label> : null}
    >
      <Select
        menuPortalTarget={document.body}
        selected={selected}
        options={allRegions}
        onChange={openCountryRoute}
        isLoading={isLoading}
        loadingMessage={() => 'Loading countries...'}
        placeholder={isLoading ? 'Loading...' : 'Select...'}
      />
    </Form.Item>
  );
};

export default CountryDropDown;
